import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { GA4_MEASUREMENT_ID, SITE_VERIFICATION } from '../seo/siteConfig';

/**
 * Sitewide verification and monitoring tags configured in routes.json.
 * Populate `integrations.siteVerification` when setting up Search Console,
 * Bing Webmaster Tools, or similar services. Set `integrations.analytics.ga4MeasurementId`
 * when ready for Google Analytics 4.
 */
export default function SitewideSeo() {
  const { google, bing } = SITE_VERIFICATION;

  useEffect(() => {
    if (!GA4_MEASUREMENT_ID || window.gtag) return undefined;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA4_MEASUREMENT_ID);

    return undefined;
  }, []);

  return (
    <Helmet prioritizeSeoTags>
      {google ? <meta name="google-site-verification" content={google} /> : null}
      {bing ? <meta name="msvalidate.01" content={bing} /> : null}
      {GA4_MEASUREMENT_ID ? (
        <>
          <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`} />
          <script>{`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA4_MEASUREMENT_ID}');
          `}</script>
        </>
      ) : null}
    </Helmet>
  );
}
